import Cookies from 'js-cookie'

interface CookieYesConsent {
    advertisement?: string
    analytics?: string
    consent?: string
    functional?: string
    necessary?: string
    performance?: string
}

export const parseCookieYesConsent = (
    cookieValue: string
): CookieYesConsent => {
    return Object.fromEntries(
        cookieValue.split(',').map(pair => pair.split(':'))
    ) as CookieYesConsent
}

export const getHasAnalyticsConsent = (consent: CookieYesConsent): boolean => {
    return consent.consent === 'yes' && consent.analytics === 'yes'
}

export const getCookieYesConsent = (): CookieYesConsent | null => {
    const cookieValue = Cookies.get('cookieyes-consent')
    if (!cookieValue) return null
    return parseCookieYesConsent(cookieValue)
}

export const getJourneyFromUrl = (
    url: string
): 'credit_cards' | 'credit_cards_alt' | 'loans_alt' => {
    if (url.includes('/credit-cards/alternative-products')) {
        return 'credit_cards_alt'
    }
    if (url.includes('/loans-alt-products')) {
        return 'loans_alt'
    }
    return 'credit_cards'
}

export const getJourneyCategoryFromJourney = (
    currentJourney: string
): 'credit_cards' | 'loans' => {
    return currentJourney?.includes('credit_cards') ? 'credit_cards' : 'loans'
}

export const getStepFromUrl = (
    url: string
): 'product_page' | 'results_page' => {
    return url.includes('/card/') ? 'product_page' : 'results_page'
}

const ORIGINAL_JOURNEY_KEY = 'inscalar_original_journey'
const ORIGINAL_JOURNEY_CATEGORY_KEY = 'inscalar_original_journey_category'

type JourneyType = 'credit_cards' | 'credit_cards_alt' | 'loans_alt'

interface OriginalJourneyData {
    journey: JourneyType
    journeyCategory: string
}

export const getOriginalJourney = (): OriginalJourneyData | null => {
    if (typeof window === 'undefined') return null

    const journey = sessionStorage.getItem(ORIGINAL_JOURNEY_KEY) as JourneyType
    const journeyCategory = sessionStorage.getItem(
        ORIGINAL_JOURNEY_CATEGORY_KEY
    )

    if (!journey || !journeyCategory) return null

    return { journey, journeyCategory }
}

export const setOriginalJourney = (data: OriginalJourneyData): void => {
    if (typeof window === 'undefined') return

    const existing = getOriginalJourney()
    if (existing) return

    sessionStorage.setItem(ORIGINAL_JOURNEY_KEY, data.journey)
    sessionStorage.setItem(ORIGINAL_JOURNEY_CATEGORY_KEY, data.journeyCategory)
}

export const getOrSetOriginalJourney = (
    currentJourney: JourneyType,
    currentJourneyCategory: string
): OriginalJourneyData => {
    const existing = getOriginalJourney()

    if (existing) {
        return existing
    }

    const newData: OriginalJourneyData = {
        journey: currentJourney,
        journeyCategory: currentJourneyCategory,
    }

    setOriginalJourney(newData)
    return newData
}
